import { Subtract } from "utility-types";
import { ApolloClient } from "apollo-client";
import { withApollo as orig, WithApolloClient } from "react-apollo";

export * from "react-apollo";

// The provided types for withApollo fail to subtract the WithApolloClient keys
// from the set of input props.
const withApollo: <P extends WithApolloClient<{}>>(
  base: React.ComponentType<P>
) => React.ComponentType<Subtract<P, WithApolloClient<{}>>> = orig as any;

export { ApolloClient, withApollo };
